import VendorTable from "./VendorTable";

export default VendorTable;
